import fetchUserData from "../data/fetchUserData";

// Redirect to subscription page if not subscribed
export default async function ({ app, redirect, $config }) {
  let userData = app.$localStore.get("userData");
  // Check user data in local storage
  if (!userData || !userData.subscribed || Date.parse(userData.endTimestamp) < Date.now()) {
    // If not subscribed, fetch updated user data
    const userData = await fetchUserData($config);
    // Update local storage
    app.$localStore.set("userData", userData);
    // Check again and redirect if not subscribed
    if (!userData.subscribed || Date.parse(userData.endTimestamp) < Date.now()) {
      return redirect("/pianifica/abbonamento");
    }
  }
}
